import log from 'loglevel';

log.setLevel('info'); // Set the desired logging level

export default log;